/**
 * Smoothly scroll to the first VISIBLE element tagged `data-section={name}`.
 *
 * Some landing sections are rendered more than once for responsive layouts (e.g. a
 * mobile copy and a desktop copy, one CSS-hidden). A plain `#hash` anchor would target
 * the first match in the DOM even when it is `display:none`, so it wouldn't scroll on
 * the other breakpoint. Picking the laid-out element (offsetParent !== null) fixes that.
 *
 * Returns true if a target was found and scrolled to, false otherwise (e.g. the section
 * isn't on the current page), so callers can decide on a fallback.
 */
export function scrollToSection(name: string): boolean {
  if (typeof document === 'undefined') return false
  const els = Array.from(document.querySelectorAll<HTMLElement>(`[data-section="${name}"]`))
  const target = els.find((el) => el.offsetParent !== null) ?? els[0]
  if (!target) return false
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return true
}
